export default __webpack_public_path__ + "static/media/users.99defde6.svg";